import { type ReactElement } from 'react'
import { getInitialism } from '@terros/common'
import { Avatar } from '@mantine/core'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'
import { AvatarBlurhash } from '../AvatarBlurhash'
import { type SearchResult } from './useRecentResults'
import { SEARCH_ENTITY_ICONS } from './types'
import classes from './spotlight.module.css'

export const SearchResultAvatar = ({ item }: { item: SearchResult }): ReactElement => {
  if ('avatarUrl' in item) {
    return (
      <span className={classes.entityAvatar}>
        <AvatarBlurhash
          avatarUrl={item.avatarUrl}
          avatarBlurhash={item.avatarBlurhash}
          color={'color' in item ? item.color : undefined}
          initials={getInitialism(item.description)}
          size={36}
          radius='50%'
        />
      </span>
    )
  }
  const icon = item.type === 'Destination' ? item.icon : SEARCH_ENTITY_ICONS.get(item.type)
  return (
    <span className={classes.entityAvatar}>
      <Avatar size={36} radius='xl'>
        <MaterialSymbolIcon icon={icon ?? 'search'} size='xl' />
      </Avatar>
    </span>
  )
}
